export const FINANCIAL_VALUE_DISPLAY_SCALES = [
    'auto',
    'units',
    'thousands',
    'millions',
    'billions',
    'trillions',
] as const;
export const FINANCIAL_VALUE_DECIMAL_PLACES = [0, 1, 2, 3, 4, 5, 6] as const;
export const FINANCIAL_VALUE_NEGATIVE_STYLES = ['accounting', 'minus'] as const;

export type FinancialValueDisplayScale = (typeof FINANCIAL_VALUE_DISPLAY_SCALES)[number];
export type FinancialValueDecimalPlaces = (typeof FINANCIAL_VALUE_DECIMAL_PLACES)[number];
export type FinancialValueNegativeStyle = (typeof FINANCIAL_VALUE_NEGATIVE_STYLES)[number];

export interface FinancialValueDisplayPreference {
    decimalPlaces: FinancialValueDecimalPlaces;
    negativeStyle: FinancialValueNegativeStyle;
    scale: FinancialValueDisplayScale;
}

export const DEFAULT_FINANCIAL_VALUE_DISPLAY: FinancialValueDisplayPreference = {
    decimalPlaces: 2,
    negativeStyle: 'accounting',
    scale: 'auto',
};
